import React,{useContext} from 'react';
import image from '../assets/SubinAdhikari-removebg-preview.png';
import Loading from '../components/common/Loading';

import {AboutPageContext} from '../context/AboutPageContextProvider';


const About = () =>{
    const {aboutpagedata,setAboutPageData} = useContext(AboutPageContext)

    return(
        <>
        {
            aboutpagedata
            ?
            <>
            <div className="container">
            <div className="row AboutPageDivRowMain ">
                <div className="col-12 d-flex flex-column p-0">

                    <div className="headerDiv w-100 d-flex justify-content-center align-items-center">
                        <div className="imageDiv d-flex justify-content-center align-items-center ml-5">
                            <img src={image} alt="image" className="img-fluid" />
                        </div>
                        <span className="name text-uppercase">{aboutpagedata[0].name}</span>

                        <div className="socialIcons mr-5 d-flex justify-content-center align-items-center">
                            <a href="https://www.github.com/SubinAdhikari" target="_blank"><i className="fa fa-github fa-2x ml-3"></i></a>
                            <a href="https://www.facebook.com/subin.adhikari.566/" target="_blank"><i className="fa fa-facebook-f fa-2x ml-3"></i></a>
                            <a href="https://www.instagram.com/subinadhikari/" target="_blank"><i className="fa fa-instagram fa-2x ml-3"></i></a>
                        </div>
                    </div>

                    <span className="contentDiv h-100 p-4">{aboutpagedata[0].desc}</span>
                </div>
            </div>
        </div>
            </>
            :
            <Loading/>
        }

        <div className="spaceInBottom"></div>
        
        </>
    )
}
export default About;
